import checkForPayoutTrans from "../objects/check_for_payout_trans";
import checkForDividendPayouts from "../objects/check_for_dividend_payouts";
import createSummaryInvestTran from "../objects/create_summary_invest_tran";
import determineInvestTaxAmt from "../objects/determine_invest_tax_amt";

export const calculateInvestPayoutTrans = (currentGameDate, monthNbr, gameInvestments, investmentMaster, 
    assetTable, gameInvestUpdtArr, bondHistoryArr, investHistoryArr)  => {
    let payoutArr = [];
    let regularTaxAmt = 0;
    let capitalTaxAmt = 0;
    for (let i=0; i<gameInvestments.length; i++){
        if (!gameInvestments[i].historyTranArr){
                gameInvestments[i].historyTranArr = [];
        }
        if (!gameInvestments[i].taxHistoryArr){
                gameInvestments[i].taxHistoryArr = [];
        }
        const beginHistoryTransNbr = gameInvestments[i].historyTranArr.length;
        const transactionArr = gameInvestments[i].transactionArr;
        if (gameInvestments[i].investType === "bond"){
            const maturityDateArr = gameInvestments[i].maturityDateArr;
            bondHistoryArr = checkForPayoutTrans(transactionArr, maturityDateArr, 
                investmentMaster, beginHistoryTransNbr, currentGameDate, monthNbr );
            if (bondHistoryArr.length > 0){
                gameInvestments[i].historyTranArr = 
                    gameInvestments[i].historyTranArr.concat(bondHistoryArr);
                if (!gameInvestUpdtArr.includes(i)){
                    gameInvestUpdtArr.push(i);
                }
                payoutArr = payoutArr.concat(bondHistoryArr);
            }
            bondHistoryArr = [];
        }else{
            const gameMonth = currentGameDate.split('-')[1];
            if (gameMonth === "03" || gameMonth === "06" ||
                gameMonth === "09" || gameMonth === "12" ){
                const summaryTranArr = createSummaryInvestTran(transactionArr, investmentMaster);
                investHistoryArr = checkForDividendPayouts(summaryTranArr, beginHistoryTransNbr, 
                    currentGameDate);
                if (investHistoryArr.length > 0){
                    gameInvestments[i].historyTranArr = 
                        gameInvestments[i].historyTranArr.concat(investHistoryArr);
                    if (!gameInvestUpdtArr.includes(i)){
                        gameInvestUpdtArr.push(i);
                    }
                    payoutArr = payoutArr.concat(investHistoryArr);
                }
                investHistoryArr = [];
            }
        }
    }
    const gameMonth = currentGameDate.split("-")[1];
    if (gameMonth === "12"){
        const taxAmtObj = 
            determineInvestTaxAmt(gameInvestments, currentGameDate, assetTable);
        regularTaxAmt = taxAmtObj.regularTaxAmt;
        capitalTaxAmt = taxAmtObj.capitalTaxAmt;
    }
  
    const returnObj = {gameInvestUpdtArr: gameInvestUpdtArr, payoutArr: payoutArr,
        regularTaxAmt: regularTaxAmt, capitalTaxAmt: capitalTaxAmt , 
    }
    return(returnObj);
    }
export default calculateInvestPayoutTrans;